module.exports = new __parcel__URL__("Mount-Diablo-Bay-View.1e5928ef.webp").toString();